import { gql } from '@apollo/client'

export const GET_PLAYLIST_ROLES = gql`
  query {
    getPlaylistRoles {
      code
    }
  }
`
